import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2421b733"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = { class: "ant-row ui-espaco-campos" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = {
  class: "",
  title: "Qual a atividade principal desenvolvida no local? "
}
const _hoisted_5 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  class: "",
  title: "Observações"
}
const _hoisted_8 = { class: "ant-row ui-espaco-campos" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = {
  class: "",
  title: "Qual o código CNAE (Classificação Nacional de Atividades Econômicas)?"
}
const _hoisted_11 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  class: "",
  title: "Observações"
}
const _hoisted_14 = { class: "ant-row ui-espaco-campos" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_16 = {
  class: "",
  title: "Como é o processo produtivo ou operacional da empresa?"
}
const _hoisted_17 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_18 = { key: 2 }
const _hoisted_19 = {
  class: "",
  title: "Observações"
}
const _hoisted_20 = { class: "ant-row ui-espaco-campos" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_22 = {
  class: "",
  title: "Quais os horários de funcionamento e número de turnos diários?"
}
const _hoisted_23 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_24 = { key: 2 }
const _hoisted_25 = {
  class: "",
  title: "Observações"
}
const _hoisted_26 = { class: "ant-row ui-espaco-campos" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_28 = {
  class: "",
  title: "O local possui risco de alagamento?"
}
const _hoisted_29 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  class: "",
  title: "Observações"
}
const _hoisted_32 = { class: "ant-row ui-espaco-campos" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_34 = {
  class: "",
  title: "Quantos colaboradores trabalham no local?"
}
const _hoisted_35 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_36 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Fixos/Proprios", -1))
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Terceiros", -1))
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { key: 2 }
const _hoisted_44 = {
  class: "",
  title: "Observações"
}
const _hoisted_45 = { class: "ant-row ui-espaco-campos" }
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_47 = {
  class: "",
  title: "Quando a operação foi iniciada no local atual e há quanto tempo está ativa?"
}
const _hoisted_48 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_49 = { key: 2 }
const _hoisted_50 = {
  class: "",
  title: "Observações"
}
const _hoisted_51 = { class: "ant-row ui-espaco-campos" }
const _hoisted_52 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_53 = {
  class: "",
  title: "O imóvel é próprio ou alugado pela empresa?"
}
const _hoisted_54 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_55 = { key: 1 }
const _hoisted_56 = {
  class: "",
  title: "Observações"
}
const _hoisted_57 = { class: "ant-row ui-espaco-campos" }
const _hoisted_58 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_59 = {
  class: "",
  title: "Qual a metragem do terreno? (m²)"
}
const _hoisted_60 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_61 = ["disabled"]
const _hoisted_62 = { key: 2 }
const _hoisted_63 = {
  class: "",
  title: "Observações"
}
const _hoisted_64 = { class: "ant-row ui-espaco-campos" }
const _hoisted_65 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_66 = {
  class: "",
  title: "Qual a área construída total, incluindo galpões, escritórios e anexos? (m²)"
}
const _hoisted_67 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_68 = ["disabled"]
const _hoisted_69 = { key: 2 }
const _hoisted_70 = {
  class: "",
  title: "Observações"
}
const _hoisted_71 = { class: "ant-row ui-espaco-campos" }
const _hoisted_72 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_73 = {
  class: "",
  title: "Existe controle formal da altura máxima de armazenagem?"
}
const _hoisted_74 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_75 = { key: 1 }
const _hoisted_76 = {
  class: "",
  title: "Observações"
}
const _hoisted_77 = { class: "ant-row ui-espaco-campos" }
const _hoisted_78 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_79 = {
  class: "",
  title: "Existem corredores de separação entre pilhas ou racks para limitar propagação de incêndio?"
}
const _hoisted_80 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_81 = { key: 1 }
const _hoisted_82 = {
  class: "",
  title: "Observações"
}
const _hoisted_83 = { class: "ant-row ui-espaco-campos" }
const _hoisted_84 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_85 = {
  class: "",
  title: "Qual o tipo predominante de luminárias/lâmpadas instaladas nas áreas operacionais e de armazenagem?"
}
const _hoisted_86 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_87 = { key: 1 }
const _hoisted_88 = { class: "ant-row" }
const _hoisted_89 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ui-espaco-campos-interno" }
const _hoisted_90 = { class: "ant-row" }
const _hoisted_91 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ui-espaco-campos-interno" }
const _hoisted_92 = { class: "ant-row" }
const _hoisted_93 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ui-espaco-campos-interno" }
const _hoisted_94 = { class: "ant-row" }
const _hoisted_95 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ui-espaco-campos-interno" }
const _hoisted_96 = { class: "ant-row" }
const _hoisted_97 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ui-espaco-campos-interno" }
const _hoisted_98 = { class: "ant-row" }
const _hoisted_99 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ui-espaco-campos-interno" }
const _hoisted_100 = { class: "ant-row" }
const _hoisted_101 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ui-espaco-campos-interno" }
const _hoisted_102 = { class: "ant-row" }
const _hoisted_103 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ui-espaco-campos-interno" }
const _hoisted_104 = ["disabled"]
const _hoisted_105 = { class: "ant-row ui-espaco-campos" }
const _hoisted_106 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_107 = {
  class: "",
  title: "Observações"
}
const _hoisted_108 = { class: "ant-row ui-espaco-campos" }
const _hoisted_109 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_110 = {
  class: "",
  title: "Existe galpões de Vinilona na empresa?"
}
const _hoisted_111 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_112 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_113 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ui-espaco-campos-interno" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "- Informar:", -1))
const _hoisted_115 = {
  key: 2,
  class: "ant-row"
}
const _hoisted_116 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "- Informar a metragem:", -1))
const _hoisted_118 = ["disabled"]
const _hoisted_119 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "- Forma que está ancorado:", -1))
const _hoisted_121 = ["disabled"]
const _hoisted_122 = {
  key: 3,
  class: "ant-row"
}
const _hoisted_123 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ui-espaco-campos-interno" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "- Existem instalações elétricas em seu interior:", -1))
const _hoisted_125 = {
  key: 4,
  class: "ant-row ui-espaco-campos"
}
const _hoisted_126 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_127 = {
  class: "",
  title: "Observações"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    titulo: "SEÇÃO 1 – INFORMAÇÕES GERAIS DA OPERAÇÃO",
    "class-titulo": 'ui-card-info-titulo-rope'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao1.atividadePrincipalVisivel,
                        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedSecao1.atividadePrincipalVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao1.atividadePrincipalVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao1.atividadePrincipalEnviarEmail
                                ? 'Remover do E-mail para Envio'
                                : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.atividadePrincipalEnviarEmail,
                            "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedSecao1.atividadePrincipalEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                    'ui-check-email-marcado': _ctx.computedSecao1.atividadePrincipalEnviarEmail
                                }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Qual a atividade principal desenvolvida no local? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('atividadePrincipal')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.atividadePrincipal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.ManualPreenchimentoInspecao.atividadePrincipal), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.atividadePrincipalVisivel)
                  ? (_openBlock(), _createBlock(_component_a_textarea, {
                      key: 1,
                      "auto-size": true,
                      value: _ctx.computedSecao1.atividadePrincipal,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedSecao1.atividadePrincipal) = $event)),
                      disabled: _ctx.props.bloquearCampos
                    }, null, 8, ["value", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.atividadePrincipalVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("label", _hoisted_7, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao1.atividadePrincipalObservacoesVisivel,
                              "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedSecao1.atividadePrincipalObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao1.atividadePrincipalObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao1.atividadePrincipalObservacoes,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedSecao1.atividadePrincipalObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao1.cnaeVisivel,
                        "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedSecao1.cnaeVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao1.cnaeVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao1.cnaeEnviarEmail
                                ? 'Remover do E-mail para Envio'
                                : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.cnaeEnviarEmail,
                            "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedSecao1.cnaeEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                    'ui-check-email-marcado': _ctx.computedSecao1.cnaeEnviarEmail
                                }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Qual o código CNAE (Classificação Nacional de Atividades Econômicas)? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('cnae')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.cnae)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.ManualPreenchimentoInspecao.cnae), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.cnaeVisivel)
                  ? (_openBlock(), _createBlock(_component_a_textarea, {
                      key: 1,
                      "auto-size": true,
                      value: _ctx.computedSecao1.cnae,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.computedSecao1.cnae) = $event)),
                      disabled: _ctx.props.bloquearCampos
                    }, null, 8, ["value", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.cnaeVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao1.cnaeObservacoesVisivel,
                              "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedSecao1.cnaeObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao1.cnaeObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao1.cnaeObservacoes,
                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedSecao1.cnaeObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao1.processoProdutivoVisivel,
                        "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.computedSecao1.processoProdutivoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao1.processoProdutivoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao1.processoProdutivoEnviarEmail
                                ? 'Remover do E-mail para Envio'
                                : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.processoProdutivoEnviarEmail,
                            "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.computedSecao1.processoProdutivoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                    'ui-check-email-marcado': _ctx.computedSecao1.processoProdutivoEnviarEmail
                                }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Como é o processo produtivo ou operacional da empresa? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('processoProdutivo')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.processoProdutivo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.ManualPreenchimentoInspecao.processoProdutivo), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.processoProdutivoVisivel)
                  ? (_openBlock(), _createBlock(_component_a_textarea, {
                      key: 1,
                      "auto-size": true,
                      value: _ctx.computedSecao1.processoProdutivo,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.computedSecao1.processoProdutivo) = $event)),
                      disabled: _ctx.props.bloquearCampos
                    }, null, 8, ["value", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.processoProdutivoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao1.processoProdutivoObservacoesVisivel,
                              "onUpdate:checked": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.computedSecao1.processoProdutivoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao1.processoProdutivoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao1.processoProdutivoObservacoes,
                            "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.computedSecao1.processoProdutivoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao1.horariosFuncionamentoVisivel,
                        "onUpdate:checked": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.computedSecao1.horariosFuncionamentoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao1.horariosFuncionamentoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao1.horariosFuncionamentoEnviarEmail
                                ? 'Remover do E-mail para Envio'
                                : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.horariosFuncionamentoEnviarEmail,
                            "onUpdate:checked": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.computedSecao1.horariosFuncionamentoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                    'ui-check-email-marcado': _ctx.computedSecao1.horariosFuncionamentoEnviarEmail
                                }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Quais os horários de funcionamento e número de turnos diários? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('horariosFuncionamento')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.horariosFuncionamento)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.ManualPreenchimentoInspecao.horariosFuncionamento), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.horariosFuncionamentoVisivel)
                  ? (_openBlock(), _createBlock(_component_a_textarea, {
                      key: 1,
                      "auto-size": true,
                      value: _ctx.computedSecao1.horariosFuncionamento,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.computedSecao1.horariosFuncionamento) = $event)),
                      disabled: _ctx.props.bloquearCampos
                    }, null, 8, ["value", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.horariosFuncionamentoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao1.horariosFuncionamentoObservacoesVisivel,
                              "onUpdate:checked": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.computedSecao1.horariosFuncionamentoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao1.horariosFuncionamentoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao1.horariosFuncionamentoObservacoes,
                            "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.computedSecao1.horariosFuncionamentoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao1.riscoAlagamentoVisivel,
                        "onUpdate:checked": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.computedSecao1.riscoAlagamentoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao1.riscoAlagamentoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao1.riscoAlagamentoEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.riscoAlagamentoEnviarEmail,
                            "onUpdate:checked": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.computedSecao1.riscoAlagamentoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao1.riscoAlagamentoEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" O local possui risco de alagamento? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('riscoAlagamento')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao1.riscoAlagamentoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao1.riscoAlagamento,
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.computedSecao1.riscoAlagamento = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao1.riscoAlagamentoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao1.riscoAlagamento,
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.computedSecao1.riscoAlagamento = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.riscoAlagamento)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.ManualPreenchimentoInspecao.riscoAlagamento), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.riscoAlagamentoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("label", _hoisted_31, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao1.riscoAlagamentoObservacoesVisivel,
                              "onUpdate:checked": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.computedSecao1.riscoAlagamentoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao1.riscoAlagamentoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao1.riscoAlagamentoObservacoes,
                            "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.computedSecao1.riscoAlagamentoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("label", _hoisted_34, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao1.colaboradoresLocalVisivel,
                        "onUpdate:checked": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.computedSecao1.colaboradoresLocalVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao1.colaboradoresLocalVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao1.colaboradoresLocalEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.colaboradoresLocalEnviarEmail,
                            "onUpdate:checked": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.computedSecao1.colaboradoresLocalEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao1.colaboradoresLocalEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Quantos colaboradores trabalham no local? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('colaboradoresLocal')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.colaboradoresLocal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.ManualPreenchimentoInspecao.colaboradoresLocal), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.colaboradoresLocalVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.computedSecao1.colaboradoresFixos) = $event)),
                          disabled: _ctx.props.bloquearCampos
                        }, null, 8, _hoisted_39), [
                          [_vModelText, _ctx.computedSecao1.colaboradoresFixos]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _hoisted_41,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.computedSecao1.colaboradoresTerceiros) = $event)),
                          disabled: _ctx.props.bloquearCampos
                        }, null, 8, _hoisted_42), [
                          [_vModelText, _ctx.computedSecao1.colaboradoresTerceiros]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.colaboradoresLocalVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao1.colaboradoresLocalObservacoesVisivel,
                              "onUpdate:checked": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.computedSecao1.colaboradoresLocalObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao1.colaboradoresLocalObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao1.colaboradoresLocalObservacoes,
                            "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.computedSecao1.colaboradoresLocalObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("label", _hoisted_47, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao1.operacaoQuandoIniciadaVisivel,
                        "onUpdate:checked": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.computedSecao1.operacaoQuandoIniciadaVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao1.operacaoQuandoIniciadaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao1.operacaoQuandoIniciadaEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.operacaoQuandoIniciadaEnviarEmail,
                            "onUpdate:checked": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.computedSecao1.operacaoQuandoIniciadaEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao1.operacaoQuandoIniciadaEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Quando a operação foi iniciada no local atual e há quanto tempo está ativa? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[40] || (_cache[40] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('operacaoQuandoIniciada')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.operacaoQuandoIniciada)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.ManualPreenchimentoInspecao.operacaoQuandoIniciada), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.operacaoQuandoIniciadaVisivel)
                  ? (_openBlock(), _createBlock(_component_a_textarea, {
                      key: 1,
                      "auto-size": true,
                      value: _ctx.computedSecao1.operacaoQuandoIniciada,
                      "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.computedSecao1.operacaoQuandoIniciada) = $event)),
                      disabled: _ctx.props.bloquearCampos
                    }, null, 8, ["value", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.operacaoQuandoIniciadaVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("label", _hoisted_50, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao1.operacaoQuandoIniciadaObservacoesVisivel,
                              "onUpdate:checked": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.computedSecao1.operacaoQuandoIniciadaObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao1.operacaoQuandoIniciadaObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao1.operacaoQuandoIniciadaObservacoes,
                            "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.computedSecao1.operacaoQuandoIniciadaObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("label", _hoisted_53, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao1.imovelProprioOuAlugadoVisivel,
                        "onUpdate:checked": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.computedSecao1.imovelProprioOuAlugadoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao1.imovelProprioOuAlugadoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao1.imovelProprioOuAlugadoEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.imovelProprioOuAlugadoEnviarEmail,
                            "onUpdate:checked": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.computedSecao1.imovelProprioOuAlugadoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao1.imovelProprioOuAlugadoEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" O imóvel é próprio ou alugado pela empresa? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[46] || (_cache[46] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('imovelProprioOuAlugado')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao1.imovelProprioOuAlugadoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao1.imovelProprio,
                        "onUpdate:checked": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.computedSecao1.imovelProprio) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Próprio")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao1.imovelProprioOuAlugadoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: _ctx.computedSecao1.imovelAlugado,
                        "onUpdate:checked": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.computedSecao1.imovelAlugado) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Alugado")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.imovelProprioOuAlugado)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_ctx.ManualPreenchimentoInspecao.imovelProprioOuAlugado), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.imovelProprioOuAlugadoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _createElementVNode("label", _hoisted_56, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao1.imovelProprioOuAlugadoObservacoesVisivel,
                              "onUpdate:checked": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.computedSecao1.imovelProprioOuAlugadoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao1.imovelProprioOuAlugadoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao1.imovelProprioOuAlugadoObservacoes,
                            "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.computedSecao1.imovelProprioOuAlugadoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("label", _hoisted_59, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao1.metragemTerrenoM2Visivel,
                        "onUpdate:checked": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.computedSecao1.metragemTerrenoM2Visivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao1.metragemTerrenoM2Visivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao1.metragemTerrenoM2EnviarEmail
                                ? 'Remover do E-mail para Envio'
                                : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.metragemTerrenoM2EnviarEmail,
                            "onUpdate:checked": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.computedSecao1.metragemTerrenoM2EnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                    'ui-check-email-marcado': _ctx.computedSecao1.metragemTerrenoM2EnviarEmail
                                }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Qual a metragem do terreno? (m²) "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[53] || (_cache[53] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('metragemTerrenoM2')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.metragemTerrenoM2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.ManualPreenchimentoInspecao.metragemTerrenoM2), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.metragemTerrenoM2Visivel)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      type: "text",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.computedSecao1.metragemTerrenoM2) = $event)),
                      disabled: _ctx.props.bloquearCampos
                    }, null, 8, _hoisted_61)), [
                      [_vModelText, _ctx.computedSecao1.metragemTerrenoM2]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.metragemTerrenoM2Visivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _createElementVNode("label", _hoisted_63, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao1.metragemTerrenoM2ObservacoesVisivel,
                              "onUpdate:checked": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.computedSecao1.metragemTerrenoM2ObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao1.metragemTerrenoM2ObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao1.metragemTerrenoM2Observacoes,
                            "onUpdate:value": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.computedSecao1.metragemTerrenoM2Observacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("label", _hoisted_66, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao1.areaConstruidaTotalM2Visivel,
                        "onUpdate:checked": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.computedSecao1.areaConstruidaTotalM2Visivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao1.areaConstruidaTotalM2Visivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao1.areaConstruidaTotalM2EnviarEmail
                                ? 'Remover do E-mail para Envio'
                                : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.areaConstruidaTotalM2EnviarEmail,
                            "onUpdate:checked": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.computedSecao1.areaConstruidaTotalM2EnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                    'ui-check-email-marcado': _ctx.computedSecao1.areaConstruidaTotalM2EnviarEmail
                                }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Qual a área construída total, incluindo galpões, escritórios e anexos? (m²) "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[59] || (_cache[59] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('areaConstruidaTotalM2')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.areaConstruidaTotalM2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_ctx.ManualPreenchimentoInspecao.areaConstruidaTotalM2), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.areaConstruidaTotalM2Visivel)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      type: "text",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.computedSecao1.areaConstruidaTotalM2) = $event)),
                      disabled: _ctx.props.bloquearCampos
                    }, null, 8, _hoisted_68)), [
                      [_vModelText, _ctx.computedSecao1.areaConstruidaTotalM2]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.areaConstruidaTotalM2Visivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                      _createElementVNode("label", _hoisted_70, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao1.areaConstruidaTotalM2ObservacoesVisivel,
                              "onUpdate:checked": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.computedSecao1.areaConstruidaTotalM2ObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao1.areaConstruidaTotalM2ObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao1.areaConstruidaTotalM2Observacoes,
                            "onUpdate:value": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.computedSecao1.areaConstruidaTotalM2Observacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("label", _hoisted_73, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemVisivel,
                        "onUpdate:checked": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemEnviarEmail,
                            "onUpdate:checked": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Existe controle formal da altura máxima de armazenagem? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[65] || (_cache[65] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('controleFormalAlturaMaximaArmazenagem')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao1.controleFormalAlturaMaximaArmazenagem,
                        onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.computedSecao1.controleFormalAlturaMaximaArmazenagem = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao1.controleFormalAlturaMaximaArmazenagem,
                        onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.computedSecao1.controleFormalAlturaMaximaArmazenagem = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.controleFormalAlturaMaximaArmazenagem)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(_ctx.ManualPreenchimentoInspecao.controleFormalAlturaMaximaArmazenagem), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                      _createElementVNode("label", _hoisted_76, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemObservacoesVisivel,
                              "onUpdate:checked": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemObservacoes,
                            "onUpdate:value": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.computedSecao1.controleFormalAlturaMaximaArmazenagemObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("label", _hoisted_79, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao1.corredoresSeparacaoPilhasRacksVisivel,
                        "onUpdate:checked": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.computedSecao1.corredoresSeparacaoPilhasRacksVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao1.corredoresSeparacaoPilhasRacksVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao1.corredoresSeparacaoPilhasRacksEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.corredoresSeparacaoPilhasRacksEnviarEmail,
                            "onUpdate:checked": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.computedSecao1.corredoresSeparacaoPilhasRacksEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao1.corredoresSeparacaoPilhasRacksEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Existem corredores de separação entre pilhas ou racks para limitar propagação de incêndio? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[72] || (_cache[72] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('corredoresSeparacaoPilhasRacks')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao1.corredoresSeparacaoPilhasRacksVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao1.corredoresSeparacaoPilhasRacks,
                        onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.computedSecao1.corredoresSeparacaoPilhasRacks = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao1.corredoresSeparacaoPilhasRacksVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao1.corredoresSeparacaoPilhasRacks,
                        onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.computedSecao1.corredoresSeparacaoPilhasRacks = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.corredoresSeparacaoPilhasRacks)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(_ctx.ManualPreenchimentoInspecao.corredoresSeparacaoPilhasRacks), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.corredoresSeparacaoPilhasRacksVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                      _createElementVNode("label", _hoisted_82, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao1.corredoresSeparacaoPilhasRacksObservacoesVisivel,
                              "onUpdate:checked": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.computedSecao1.corredoresSeparacaoPilhasRacksObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao1.corredoresSeparacaoPilhasRacksObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao1.corredoresSeparacaoPilhasRacksObservacoes,
                            "onUpdate:value": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.computedSecao1.corredoresSeparacaoPilhasRacksObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("label", _hoisted_85, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao1.tipoLuminariasLampadasVisivel,
                        "onUpdate:checked": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.computedSecao1.tipoLuminariasLampadasVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao1.tipoLuminariasLampadasVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao1.tipoLuminariasLampadasEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.tipoLuminariasLampadasEnviarEmail,
                            "onUpdate:checked": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.computedSecao1.tipoLuminariasLampadasEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao1.tipoLuminariasLampadasEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Qual o tipo predominante de luminárias/lâmpadas instaladas nas áreas operacionais e de armazenagem? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[79] || (_cache[79] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('tipoLuminariasLampadas')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.manuaisPreenchimento.tipoLuminariasLampadas)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(_ctx.ManualPreenchimentoInspecao.tipoLuminariasLampadas), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.tipoLuminariasLampadasVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.luminariasLampadasLed,
                            "onUpdate:checked": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.computedSecao1.luminariasLampadasLed) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("LED")
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.luminariasLampadasFluorescente,
                            "onUpdate:checked": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.computedSecao1.luminariasLampadasFluorescente) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Fluorescente")
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.luminariasLampadasVaporMercurio,
                            "onUpdate:checked": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.computedSecao1.luminariasLampadasVaporMercurio) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Vapor de Mercúrio")
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("div", _hoisted_95, [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.luminariasLampadasVaporSodio,
                            "onUpdate:checked": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.computedSecao1.luminariasLampadasVaporSodio) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Vapor de Sódio")
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", _hoisted_97, [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.luminariasLampadasMetalicaVaporMetalico,
                            "onUpdate:checked": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.computedSecao1.luminariasLampadasMetalicaVaporMetalico) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Metálica (Vapor Metálico)")
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("div", _hoisted_99, [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.luminariasLampadasHalogena,
                            "onUpdate:checked": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.computedSecao1.luminariasLampadasHalogena) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Halógena")
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_100, [
                        _createElementVNode("div", _hoisted_101, [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.luminariasLampadasIncandescente,
                            "onUpdate:checked": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.computedSecao1.luminariasLampadasIncandescente) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Incandescente")
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("div", _hoisted_103, [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.luminariasLampadasMista,
                            "onUpdate:checked": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.computedSecao1.luminariasLampadasMista) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Mista (especificar)")
                            ]),
                            _: 1
                          }, 8, ["checked"]),
                          (_ctx.computedSecao1.luminariasLampadasMista)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.computedSecao1.luminariasLampadasMistaEspecificacao) = $event)),
                                disabled: _ctx.props.bloquearCampos
                              }, null, 8, _hoisted_104)), [
                                [_vModelText, _ctx.computedSecao1.luminariasLampadasMistaEspecificacao]
                              ])
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("div", _hoisted_106, [
                          _createElementVNode("label", _hoisted_107, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "Apresentar este campo no relatório?"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_checkbox, {
                                  checked: _ctx.computedSecao1.luminariasLampadasObservacoesVisivel,
                                  "onUpdate:checked": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.computedSecao1.luminariasLampadasObservacoesVisivel) = $event))
                                }, null, 8, ["checked"])
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" Observações:")
                          ]),
                          (_ctx.computedSecao1.luminariasLampadasObservacoesVisivel)
                            ? (_openBlock(), _createBlock(_component_a_textarea, {
                                key: 0,
                                "auto-size": true,
                                value: _ctx.computedSecao1.luminariasLampadasObservacoes,
                                "onUpdate:value": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.computedSecao1.luminariasLampadasObservacoes) = $event)),
                                disabled: _ctx.props.bloquearCampos
                              }, null, 8, ["value", "disabled"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("label", _hoisted_110, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao1.possuiGalpoesVinilonaVisivel,
                        "onUpdate:checked": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.computedSecao1.possuiGalpoesVinilonaVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao1.possuiGalpoesVinilonaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao1.possuiGalpoesVinilonaEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao1.possuiGalpoesVinilonaEnviarEmail,
                            "onUpdate:checked": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.computedSecao1.possuiGalpoesVinilonaEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao1.possuiGalpoesVinilonaEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Existe galpões de Vinilona na empresa? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[93] || (_cache[93] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiGalpoesVinilona')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao1.possuiGalpoesVinilonaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao1.possuiGalpoesVinilona,
                        onClick: _cache[94] || (_cache[94] = ($event: any) => (_ctx.computedSecao1.possuiGalpoesVinilona = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao1.possuiGalpoesVinilonaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao1.possuiGalpoesVinilona,
                        onClick: _cache[95] || (_cache[95] = ($event: any) => (_ctx.computedSecao1.possuiGalpoesVinilona = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiGalpoesVinilona)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_111, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiGalpoesVinilona), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.possuiGalpoesVinilona)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                      _createElementVNode("div", _hoisted_113, [
                        _hoisted_114,
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao1.galpoesVinilonaProprio,
                          "onUpdate:checked": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.computedSecao1.galpoesVinilonaProprio) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Próprio")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao1.galpoesVinilonaAlugado,
                          "onUpdate:checked": _cache[97] || (_cache[97] = ($event: any) => ((_ctx.computedSecao1.galpoesVinilonaAlugado) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Alugado")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.possuiGalpoesVinilona)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                      _createElementVNode("div", _hoisted_116, [
                        _hoisted_117,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((_ctx.computedSecao1.galpoesVinilonaMetragemM2) = $event)),
                          disabled: _ctx.props.bloquearCampos
                        }, null, 8, _hoisted_118), [
                          [_vModelText, _ctx.computedSecao1.galpoesVinilonaMetragemM2]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_119, [
                        _hoisted_120,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.computedSecao1.galpoesVinilonaFormaAncoragem) = $event)),
                          disabled: _ctx.props.bloquearCampos
                        }, null, 8, _hoisted_121), [
                          [_vModelText, _ctx.computedSecao1.galpoesVinilonaFormaAncoragem]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.possuiGalpoesVinilona)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                      _createElementVNode("div", _hoisted_123, [
                        _hoisted_124,
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao1.galpoesVinilonaPossuiInstalacaoEletricaInterior,
                          onClick: _cache[100] || (_cache[100] = ($event: any) => (_ctx.computedSecao1.galpoesVinilonaPossuiInstalacaoEletricaInterior = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sim")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: !_ctx.computedSecao1.galpoesVinilonaPossuiInstalacaoEletricaInterior,
                          onClick: _cache[101] || (_cache[101] = ($event: any) => (_ctx.computedSecao1.galpoesVinilonaPossuiInstalacaoEletricaInterior = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Não")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao1.possuiGalpoesVinilona)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                      _createElementVNode("div", _hoisted_126, [
                        _createElementVNode("label", _hoisted_127, [
                          _createVNode(_component_a_tooltip, {
                            placement: "top",
                            title: "Apresentar este campo no relatório?"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_checkbox, {
                                checked: _ctx.computedSecao1.galpoesVinilonaObservacoesVisivel,
                                "onUpdate:checked": _cache[102] || (_cache[102] = ($event: any) => ((_ctx.computedSecao1.galpoesVinilonaObservacoesVisivel) = $event))
                              }, null, 8, ["checked"])
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Observações:")
                        ]),
                        (_ctx.computedSecao1.galpoesVinilonaObservacoesVisivel)
                          ? (_openBlock(), _createBlock(_component_a_textarea, {
                              key: 0,
                              "auto-size": true,
                              value: _ctx.computedSecao1.galpoesVinilonaObservacoes,
                              "onUpdate:value": _cache[103] || (_cache[103] = ($event: any) => ((_ctx.computedSecao1.galpoesVinilonaObservacoes) = $event)),
                              disabled: _ctx.props.bloquearCampos
                            }, null, 8, ["value", "disabled"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}